import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../ProfileCommon/Breadcrumb";
import LoadingCommon from "../../../../components/common/LoadingStatus/LoadingCommon";
import termsOfUseData from "./../../../../contanst/termsOfUseData.json";
import FooterContact from "../../../../components/Footer/FooterContact";
const TermsOfUse = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
      <LoadingCommon statusLoading={isLoading} />
        <div className="flex flex-col gap-2 flex-1 px-[30px] pb-[120px]">
          <Breadcrumb
            classNameTitle={"text-[#333333] mb-4"}
            breadCrumbTiltle={t("support.termsOfUse")}
            onClickBack={() =>
              navigate("/profile/support", {
                state: { direction: -1 },
                replace: false,
              })
            }
          />

          <div className="flex flex-col gap-1 text-[14px] xs:text-[16px] mb-4">
            <span className={"text-sm"}>Effective Date: 5 September 2025</span>
            <span className={"text-sm"}>Last Updated: 5 September 2025</span>
          </div>

          <div>
            <h3 className={"text-[#333333] text-sm font-bold"}>
              1.Introduction
            </h3>
            <div className="pl-[13px]">
              <span className={"text-sm"}>
                Welcome to Rally, the customer intelligence platform that
                rewards you for sharing your dining experiences. These Terms of
                Use ("Terms") govern your use of the Rally mobile application
                ("App") and related services ("Services") provided by Rally AI
                Pte Ltd ("Rally," "we," "us," or "our")
              </span>

              <h6 className="mt-4 text-black font-semibold text-sm">
                By downloading, accessing, or using the Rally App, you agree to
                be bound by these Terms. If you do not agree to these Terms,
                please do not use our App or Services.
              </h6>
              <h3 className={"text-[#333333] text-sm font-bold mt-4"}>
                Company Information
              </h3>

              <ul className="list-disc pl-5">
                <li className={"text-sm"}>Company Name: Rally AI Pte Ltd</li>
                <li className={"text-sm"}>
                  Registration: Singapore Company (Registered 22 January 2025)
                </li>
                <li className={"text-sm"}>
                  Contact Email:{" "}
                  <a
                    className=" underline decoration-offset-0 decoration-[0px]"
                    href="mailto:hello@letsrally.ai"
                  >
                    hello@letsrally.ai
                  </a>
                </li>
                <li className={"text-sm"}>Contact Phone: +65 8362 9230</li>
              </ul>
            </div>
          </div>
          <div>
            <h3 className={"text-[#333333] text-sm font-bold"}>
              2.Service Description
            </h3>
            <div className="pl-[13px]">
              <span className={"text-sm"}>
                Rally connects food and beverage businesses with consumers
                through an engaging quest-based platform. As a user, you can:
              </span>
              <ul className="list-disc pl-5">
                <li className={"text-sm"}>
                  Complete various "quests" including surveys, photo
                  submissions, check-ins, and social sharing activities
                </li>
                <li className={"text-sm"}>Earn Rally Tokens, XP points, and achievement badges</li>
                <li className={"text-sm"}>Convert tokens to cash rewards</li>
                <li className={"text-sm"}>Progress through 10 levels of gamified experiences</li>
                <li className={"text-sm"}>
                  Participate in co-creation, mystery shopping, and social
                  advocacy activities
                </li>
                <h3 className={"text-[#333333] text-sm font-bold mt-4"}>
                  Quest types
                </h3>
                <span className={"text-sm"}>
                  Our platform currently offers Foundation Quests with
                  additional categories planned for future release:
                </span>
                <ul className="list-disc pl-5">
                  <li className={"text-sm"}>
                    <strong>Foundation Quests:</strong> Customer segmentation,
                    journey mapping, and snap surveys
                  </li>
                  <li className={"text-sm"}>
                    <strong>Co-Creation Quests:</strong> Menu innovation, design
                    contests, recipe creation
                  </li>
                  <li className={"text-sm"}>
                    <strong>Social Advocacy Quests:</strong> Photo campaigns,
                    referral programs, review initiatives
                  </li>
                  <li className={"text-sm"}>
                    <strong>Mystery Experience Quests:</strong> Secret shopping,
                    service audits, timing challenges
                  </li>
                  <li className={"text-sm"}>
                    <strong>Market Intelligence Quests:</strong> Trend
                    validation, competitive analysis, preference testing
                  </li>
                </ul>
              </ul>
            </div>
          </div>

          <div className="space-y-6">
            {termsOfUseData.map((section, sectionIndex) => (
              <div key={sectionIndex}>
                <div className="flex flex-row">
                  <h3 className={"text-[#333333] text-sm font-bold"}>
                    {sectionIndex + 3}.
                  </h3>
                  <h3 className={"text-[#333333] text-sm font-bold"}>
                    {section.section}
                  </h3>
                </div>

                {section.subsections.map((sub, subIndex) => (
                  <div key={subIndex} className="mb-4 pl-[13px]">
                    <h3 className="font-semibold text-sm mb-2">{sub.title}</h3>
                    <span className={"text-sm"}>{sub.subItems}</span>
                    <ul className="list-disc pl-5 space-y-1">
                      {sub.items.map((item, itemIndex) => (
                        <li className="text-sm" key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div>
            <h3 className={"text-[#333333] text-sm font-bold"}>
              14. Contact Information
            </h3>
            <div className="pl-[13px]">
              <span className={"text-sm"}>
                If you have questions about these Terms or need support:
              </span>

              <h3 className={"text-[#333333] text-sm font-bold mt-4"}>
                Rally AI Pte Ltd
              </h3>

              <ul className="list-disc pl-5">
                <li className={"text-sm"}>
                  {" "}
                  <strong>Email:</strong> hello@letsrally.ai
                </li>
                <li className={"text-sm"}>
                  {" "}
                  <strong>Phone:</strong> +65 8362 9230
                </li>
                <li className={"text-sm"}>
                  {" "}
                  <strong>Business Hours:</strong> Monday-Friday, 10:00 AM -
                  6:00 PM SGT
                </li>
              </ul>

              <span className={"text-sm"}>
                For urgent account issues or technical support, please contact
                us through the in-app support feature.
              </span>
            </div>
          </div>
          <hr />
          <h6 className="mt-4 text-black font-semibold text-sm">
            By using the Rally App, you acknowledge that you have read,
            understood, and agree to be bound by these Terms of Use.
          </h6>
          {/* {termOfUse.map((item, index) => (
            <div key={index} className="mb-2">
              <h3 className={"text-[#333333] text-sm font-bold"}>
                {index + 1}. {item.title}
              </h3>
              <div className="pl-[13px]">
                <span className="text-[#333333] text-sm font-normal ">
                  {item.content}
                </span>
              </div>
            </div>
          ))} */}
        </div>
      <FooterContact className={"!bg-white"} />
    </div>
  );
};

export default TermsOfUse;
